import {
  setMessageVisibility,
  getCheckoutOwnerData,
  getQuotation,
  getIsOperatorFromSelector,
} from 'app/services/businessFunctionHelpers';
import { MessagesEnum, FormsEnum } from 'app/shared/enums';
import { checkIsDataObfuscated } from 'app/services/businessFunctions/helpers/checkIsDataObfuscated';
import { handleObfuscatedFieldConsentReset } from 'app/services/businessFunctions/helpers/handleObfuscatedFieldConsentReset';

const ownerObfuscation = {
  showCarOwnerNameObfuscatedMessage(initialRun?: boolean) {
    const { nameCheckoutForm } = getCheckoutOwnerData();
    const quotation = getQuotation();
    const isOperator = getIsOperatorFromSelector();
    handleObfuscatedFieldConsentReset({
      value: nameCheckoutForm || '',
      initialRun,
      messageKey: MessagesEnum.CarOwnerNameObfuscated,
      formName: FormsEnum.CheckoutForm,
      quotation,
      isOperator,
      resetTarget: {
        type: 'person',
        trackedPerson: 'owner',
        field: 'name',
      },
    });
  },
  showCarOwnerLastNameObfuscatedMessage(initialRun?: boolean) {
    const { lastNameCheckoutForm } = getCheckoutOwnerData();
    const quotation = getQuotation();
    const isOperator = getIsOperatorFromSelector();
    handleObfuscatedFieldConsentReset({
      value: lastNameCheckoutForm || '',
      initialRun,
      messageKey: MessagesEnum.CarOwnerLastNameObfuscated,
      formName: FormsEnum.CheckoutForm,
      quotation,
      isOperator,
      resetTarget: {
        type: 'person',
        trackedPerson: 'owner',
        field: 'lastName',
      },
    });
  },
  showCarOwnerPeselObfuscatedMessage(initialRun?: boolean) {
    const { peselCheckoutForm } = getCheckoutOwnerData();
    const quotation = getQuotation();
    const isOperator = getIsOperatorFromSelector();
    handleObfuscatedFieldConsentReset({
      value: peselCheckoutForm || '',
      initialRun,
      messageKey: MessagesEnum.CarOwnerPeselObfuscated,
      formName: FormsEnum.CheckoutForm,
      quotation,
      isOperator,
      resetTarget: {
        type: 'person',
        trackedPerson: 'owner',
        field: 'peselNumber',
      },
    });
  },
  showOwnerPassportObfuscatedMessage(initialRun?: boolean) {
    const { passport } = getCheckoutOwnerData();

    const showObfuscatedMessage = checkIsDataObfuscated(passport, initialRun);

    setMessageVisibility({
      key: MessagesEnum.OwnerPassportObfuscated,
      visible: showObfuscatedMessage,
      formName: FormsEnum.CheckoutForm,
    });
  },
  showCarOwnerFamilyNameObfuscatedMessage(initialRun?: boolean) {
    const { familyName } = getCheckoutOwnerData();

    const showObfuscatedMessage = checkIsDataObfuscated(familyName, initialRun);

    setMessageVisibility({
      key: MessagesEnum.CarOwnerFamilyNameObfuscated,
      visible: showObfuscatedMessage,
      formName: FormsEnum.CheckoutForm,
    });
  },
  showCarOwnerLegalAddressStreetNameObfuscatedMessage(initialRun?: boolean) {
    const { legalAddress } = getCheckoutOwnerData();

    const showObfuscatedMessage = checkIsDataObfuscated(
      legalAddress?.streetName,
      initialRun
    );

    setMessageVisibility({
      key: MessagesEnum.CarOwnerLegalAddressStreetNameObfuscated,
      visible: showObfuscatedMessage,
      formName: FormsEnum.CheckoutForm,
    });
  },
  showCarOwnerHomeAddressStreetNameObfuscatedMessage(initialRun?: boolean) {
    const { homeAddress } = getCheckoutOwnerData();

    const showObfuscatedMessage = checkIsDataObfuscated(
      homeAddress?.streetName,
      initialRun
    );

    setMessageVisibility({
      key: MessagesEnum.CarOwnerHomeAddressStreetNameObfuscated,
      visible: showObfuscatedMessage,
      formName: FormsEnum.CheckoutForm,
    });
  },
};

export default ownerObfuscation;
